<template>
  <el-card>
    <div slot="header">
      下载列表
      <el-button style="float: right" type="text" @click="fetch()"
        >刷新列表
      </el-button>
    </div>
    <element-table
      ref="table"
      :data="downloadList"
      :columns="columns"
      :loading="loading"
      :height="tableHeight"
      border
    ></element-table>
    <el-pagination
      ref="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="pagesize"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.totalCount"
      style="margin-top: 20px"
      class="table-pagination"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import debounce from "lodash/debounce";
import { formatDate } from "@/utils/common";
import ElementTable from "@/components/ElementTable";
import download from "@/api/download";
import Page from "@/mixin/Page";

export default {
  components: {
    ElementTable,
  },
  mixins: [Page],
  data() {
    return {
      downloadList: [],
      loading: false,
      columns: [
        {
          title: "报表名称",
          key: "fileName",
          align: "center",
        },
        {
          title: "开始时间",
          key: "startTime",
          align: "center",
          render(h, params) {
            const startTime = params.row.startTime;
            return <div>{formatDate(startTime)}</div>;
          },
        },
        {
          title: "结束时间",
          key: "endTime",
          align: "center",
          render(h, params) {
            const endTime = params.row.endTime;
            return <div>{formatDate(endTime)}</div>;
          },
        },
        {
          title: "状态",
          key: "downloadState",
          align: "center",
          render(h, params) {
            const stateMap = {
              SUBMIT: "已提交",
              WAITING: "等待中",
              CANCEL: "已取消",
              REJECTED: "已拒绝",
              RUNNING: "运行中",
              EXCEPTION: "异常",
              COMPLETED: "已完成",
            };
            const tagTypeMap = {
              SUBMIT: "warning",
              WAITING: "warning",
              CANCEL: "danger",
              REJECTED: "danger",
              RUNNING: "",
              EXCEPTION: "danger",
              COMPLETED: "success",
            };
            const state = params.row.downloadState;
            return <el-tag type={tagTypeMap[state]}>{stateMap[state]}</el-tag>;
          },
        },
        {
          title: "下载",
          width: 150,
          key: "downloadState",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            let operation = [];

            if (this.$hasPermission(this.$route, "download")) {
              operation.push(
                <el-button
                  v-show={row.downloadState == "COMPLETED"}
                  type="text"
                >
                  <a href={row.filePath}>下载</a>
                </el-button>
              );
            }
            return operation;
          },
        },
        {
          title: "备注",
          width: 150,
          key: "remark",
          align: "center",
          tooltip: true,
        },
      ],
      tableHeight: 300,
    };
  },
  mounted() {
    this.fetch();
    this.changeTableHeight();
    this.__resizeHandler = debounce(() => {
      this.changeTableHeight();
    }, 100);
    window.addEventListener("resize", this.__resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.__resizeHandler);
  },
  activated() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      download
        .getDownloadHistory({
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        })
        .then((res) => {
          this.loading = false;
          this.downloadList = res.result;
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination = { ...this.pagination, ...pageInfo };
        });
    },
    changeTableHeight() {
      this.$nextTick(() => {
        const wHeight = window.innerHeight;
        const cardHeaderHeight = 59;
        const cardHeight = wHeight - 64 - 48 - 40 - 2;
        const innerHeight = cardHeight - cardHeaderHeight;
        const paginationHeight = this.$refs.pagination.$el.offsetHeight + 20;
        const tableHeight = innerHeight - paginationHeight;
        this.tableHeight = tableHeight > 300 ? tableHeight : 300;
      });
    },
  },
};
</script>
